import React, { useRef } from 'react';
import Slider from 'react-slick';

import './styles.scss';

const GalleryImages = ({ headline = 'On the campaign trail', images }) => {
  const sliderRef = useRef();

  const Settings = {
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 1000,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const handleDownloadImages = async () => {
    for (const wrapper of images) {
      try {
        const response = await fetch(wrapper.image?.url, { responseType: 'blob' });

        if (response.ok) {
          const blob = await response.blob();
          const imageUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = imageUrl;
          link.download = wrapper.image?.filename || 'image.jpg';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(imageUrl);
        } else {
          console.error('Failed to download image:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error downloading image:', error);
      }
    }
  };

  return (
    <div className="gallery-images">
      <div className="container">
        <div className="header">
          <h3>{headline}</h3>
          <button onClick={handleDownloadImages}>Download images</button>
        </div>

        <div className="images-gallery">
          <Slider ref={sliderRef} {...Settings}>
            {images.map((image) => (
              <img src={image.image.url} alt={image.image.alt || ''} className="images-gallery-photo" />
            ))}
          </Slider>
        </div>

        <div className="cta-mobile">
          <button onClick={handleDownloadImages}>Download images</button>
        </div>
      </div>
    </div>
  );
};

export default GalleryImages;

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path
          d="M48.1047 42.0571L23 42.0571L23 37.9429L48.1047 37.9429L37.0415 26.9087L39.9579 24L56 40L39.9579 56L37.0415 53.0913L48.1047 42.0571Z"
          fill="white"
        />
        <circle cx="40" cy="40" r="38" stroke="white" stroke-width="4" />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path
          d="M31.8953 37.9429L57 37.9429L57 42.0571L31.8953 42.0571L42.9585 53.0913L40.0421 56L24 40L40.0421 24L42.9585 26.9087L31.8953 37.9429Z"
          fill="white"
        />
        <circle cx="40" cy="40" r="38" transform="rotate(-180 40 40)" stroke="white" stroke-width="4" />
      </svg>
    </div>
  );
}
